(function () {
  function resetSelect(select) {
    if (!select || !select.options || !select.options.length) return;
    select.selectedIndex = 0;
    select.value = select.options[0].value;
  }

  function resetCustom(root) {
    if (!root) return;
    var label = root.querySelector('[data-acc-ro-shopping-country-label]');
    var options = root.querySelectorAll('[data-acc-ro-shopping-country-option]');
    var placeholder = root.getAttribute('data-acc-ro-shopping-country-placeholder') || 'Select';

    closeMenu(root);

    for (var i = 0; i < options.length; i += 1) {
      var isPlaceholder = !(options[i].getAttribute('data-url') || '');
      options[i].classList.toggle('is-selected', isPlaceholder);
      options[i].setAttribute('aria-selected', isPlaceholder ? 'true' : 'false');
      if (isPlaceholder && options[i].getAttribute('data-label')) {
        placeholder = options[i].getAttribute('data-label');
      }
    }

    if (label) {
      label.textContent = placeholder;
    }
  }

  function resetAll(scope) {
    var root = scope || document;
    var selects = root.querySelectorAll
      ? root.querySelectorAll('[data-acc-ro-shopping-country-select]')
      : [];
    for (var i = 0; i < selects.length; i += 1) {
      resetSelect(selects[i]);
    }

    var customs = root.querySelectorAll
      ? root.querySelectorAll('[data-acc-ro-shopping-country]')
      : [];
    for (var c = 0; c < customs.length; c += 1) {
      if (customs[c].querySelector('[data-acc-ro-shopping-country-trigger]')) {
        resetCustom(customs[c]);
      }
    }
  }

  function bindSelect(select) {
    if (!select || select.dataset.accRoShoppingCountryBound === 'true') return;
    select.dataset.accRoShoppingCountryBound = 'true';
    select.setAttribute('autocomplete', 'off');
    select.addEventListener('change', function () {
      var option = select.options[select.selectedIndex];
      var url = option && option.getAttribute('data-url');
      // Match control: leave UI on Select when navigating away / returning via back.
      resetSelect(select);
      if (url) {
        window.location.href = url;
      }
    });
  }

  function closeMenu(root) {
    var trigger = root.querySelector('[data-acc-ro-shopping-country-trigger]');
    var menu = root.querySelector('[data-acc-ro-shopping-country-menu]');
    if (!trigger || !menu) return;
    trigger.setAttribute('aria-expanded', 'false');
    menu.hidden = true;
  }

  function openMenu(root) {
    var trigger = root.querySelector('[data-acc-ro-shopping-country-trigger]');
    var menu = root.querySelector('[data-acc-ro-shopping-country-menu]');
    if (!trigger || !menu) return;
    trigger.setAttribute('aria-expanded', 'true');
    menu.hidden = false;
  }

  function bindCustom(root) {
    if (!root || root.dataset.accRoShoppingCountryBound === 'true') return;
    var trigger = root.querySelector('[data-acc-ro-shopping-country-trigger]');
    var menu = root.querySelector('[data-acc-ro-shopping-country-menu]');
    var options = root.querySelectorAll('[data-acc-ro-shopping-country-option]');
    if (!trigger || !menu) return;

    root.dataset.accRoShoppingCountryBound = 'true';

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (trigger.getAttribute('aria-expanded') === 'true') {
        closeMenu(root);
      } else {
        openMenu(root);
      }
    });

    for (var i = 0; i < options.length; i += 1) {
      (function (option) {
        option.addEventListener('click', function (event) {
          event.preventDefault();
          var url = option.getAttribute('data-url') || '';

          closeMenu(root);

          // Keep closed label on Select (control behavior); only redirect when URL set.
          resetCustom(root);

          if (url) {
            window.location.href = url;
          }
        });
      })(options[i]);
    }
  }

  function init(scope) {
    var root = scope || document;
    var selects = root.querySelectorAll
      ? root.querySelectorAll('[data-acc-ro-shopping-country-select]')
      : [];
    for (var i = 0; i < selects.length; i += 1) {
      bindSelect(selects[i]);
    }

    var customs = root.querySelectorAll
      ? root.querySelectorAll('[data-acc-ro-shopping-country]')
      : [];
    for (var c = 0; c < customs.length; c += 1) {
      if (customs[c].querySelector('[data-acc-ro-shopping-country-trigger]')) {
        bindCustom(customs[c]);
      }
    }

    resetAll(root);
  }

  document.addEventListener('click', function (event) {
    var openRoots = document.querySelectorAll(
      '[data-acc-ro-shopping-country] [data-acc-ro-shopping-country-trigger][aria-expanded="true"]'
    );
    for (var i = 0; i < openRoots.length; i += 1) {
      var root = openRoots[i].closest('[data-acc-ro-shopping-country]');
      if (root && !root.contains(event.target)) {
        closeMenu(root);
      }
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var openRoots = document.querySelectorAll(
      '[data-acc-ro-shopping-country] [data-acc-ro-shopping-country-trigger][aria-expanded="true"]'
    );
    for (var i = 0; i < openRoots.length; i += 1) {
      var root = openRoots[i].closest('[data-acc-ro-shopping-country]');
      if (root) closeMenu(root);
    }
  });

  // Browser back/forward (bfcache) restores prior select state — force Select like control.
  window.addEventListener('pageshow', function () {
    resetAll(document);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
